import { IGetOfferByIdResponse } from '@/services/store/interfaces/offers.interfaces';
import { Order } from '@/templates/NewStore/types/order';

const getInitials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const parseKm = (distanceText?: string) => {
  if (!distanceText) return 0;
  const m = distanceText.replace(',', '.').match(/(\d+(\.\d+)?)/);
  return m ? Number(m[1]) : 0;
};

const parseRequestsCount = (text?: string) => {
  if (!text) return 0;
  const m = text.match(/(\d+)/);
  return m ? Number(m[1]) : 0;
};

export function parseOfferByIdToOrder(params: {
  offerId: string; // ex: "10421634-37727316"
  response: IGetOfferByIdResponse;
}): Order {
  const { offerId, response } = params;
  const tip = response.tip;

  const memberSince =
    tip.requests_summary?.find((x) =>
      (x.title ?? '').toLowerCase().includes('primeiro')
    )?.value ?? '';

  const completedRequestsText =
    tip.requests_summary?.find((x) =>
      (x.title ?? '').toLowerCase().includes('pedidos')
    )?.value ?? '';

  const completedRequests = parseRequestsCount(completedRequestsText);

  const photos = (tip.images ?? []).map((img) => img.url).filter(Boolean);

  const questionsAndAnswers = (tip.infos ?? [])
    .map((info) => {
      const question = (info.label ?? '').trim();
      const answer = (info.value ?? []).filter(Boolean).join('\n').trim();
      return { question, answer };
    })
    // remove linhas “vazias” (ex: Informações Adicionais = [""])
    .filter((qa) => qa.question && qa.answer);

  const city = (tip.address ?? '').trim();
  const state = ''; // API não traz UF separado aqui
  const zipCode = ''; // API não traz CEP separado aqui

  return {
    id: offerId,

    customerName: tip.customer ?? '',
    customerInitials: getInitials(tip.customer ?? ''),

    // mantendo o layout: usa title direto
    category: tip.title ?? '',

    serviceType: tip.is_remote ? 'Remoto' : 'Presencial',
    isRemote: tip.is_remote,

    description: (tip.additional_info ?? '').trim(),

    // A API não traz createdAt nesse payload → usa agora
    createdAt: new Date(),

    distance: parseKm(tip.distance),
    neighbourhood: '',

    unlockedCount: tip.leads_count ?? 0,
    maxUnlocks: tip.max_accepted ?? 0,

    isUrgent: tip.urgency === 0,
    isHighlighted: tip.customer_paid,
    isRecommended: false,
    isViewed: tip.status !== 'unread',

    coinCost: tip.price ?? 0,

    attachedImages: photos.length,
    photos,

    suggestedPrice: undefined,
    estimatedDuration: undefined,

    location: {
      city,
      state,
      zipCode,
    },

    questionsAndAnswers,

    clientInfo: {
      memberSince,
      completedRequests,
      hasWhatsApp: Boolean(tip.valid_phone),
    } as any,
  };
}
